"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

import Envelope from "@/components/icons/envelope-outline.svg";

interface ContactFormProps {
  submitPath: string;
  currentPage?: string;
  extraFields?: {
    type: "string" | "dropdown"
    placeholder: string;
    possibleValues?: { value: string, label?: string, notAnOption?: boolean }[];
    defaultValue?: string;
  }[];
}

export default function ContactForm(props: ContactFormProps) {

  const t = useTranslations("About");

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [emailValidity, setEmailValidity] = useState<boolean>(true);

  const [successAlert, setSuccessAlert] = useState<string | null>(null);
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  useEffect(() => {
    if (successAlert && successAlert.length > 0) {
      setTimeout(() => {
        setSuccessAlert(null);
      }, 5000);
    }
  }, [successAlert]);

  useEffect(() => {
    if (errorAlert && errorAlert.length > 0) {
      setTimeout(() => {
        setErrorAlert(null);
      }, 5000);
    }
  }, [errorAlert]);

  function canBeSubmitted() {
    return firstName.trim().length > 0 && lastName.trim().length > 0 && email.trim().length > 0 && message.trim().length > 0 && emailValidity
  }

  function clearForm() {
    setFirstName("");
    setLastName("");
    setCompany("");
    setEmail("");
    setMessage("");
  }

  function onSubmitClick() {
    fetch(props.submitPath, { method: "POST", body: JSON.stringify({ firstName, lastName, company, email, message, page: props.currentPage }) })
      .then(res => res.json())
      .then(res => {
        setSuccessAlert(t("contact_req_submitted"));
        clearForm();
      })
      .catch(err => {
        console.error(`Error while sending contact form: ${err}`);
        setErrorAlert(JSON.stringify(err));
      });
  }

  return (
    <div className="flex flex-col items-center gap-2.5 w-full">
      <div className="w-full">
        {successAlert && (<div className="alert alert-success">
          <span>{successAlert}</span>
        </div>)}
        {errorAlert && (<div className="alert alert-error">
          <span>{errorAlert}</span>
        </div>)}
      </div>
      <div className="flex flex-col gap-y-2.5 md:flex-row md:gap-x-2.5 w-full">
        <input className="input md:flex-1" type="text" required placeholder={t('field_firstname')} onChange={e => setFirstName(e.target.value)} value={firstName} />
        <input className="input md:flex-1" type="text" required placeholder={t('field_lastname')} onChange={e => setLastName(e.target.value)} value={lastName} />
      </div>
      <div className="flex flex-col gap-y-2.5 md:flex-row md:gap-x-2.5 w-full">
        <input className="input md:flex-1" type="text" placeholder={t('field_company')} onChange={e => setCompany(e.target.value)} value={company} />
        <input className="input md:flex-1 validator" type="email" required placeholder={t('field_email')} onChange={e => { setEmail(e.target.value); setEmailValidity(!e.target.validity.typeMismatch); }} value={email} />
      </div>
      <div className="flex flex-col md:flex-row w-full">
        <textarea className="textarea w-full" required placeholder={t('field_message')} onChange={e => setMessage(e.target.value)} value={message}></textarea>
      </div>
      <div className="p-2.5">
        <button className={"btn btn-secondary text-white rounded-full"} onClick={onSubmitClick} disabled={!canBeSubmitted()}>
          <Envelope height={14} width={14} className="stroke-white" />
          {t("form_submit")}
        </button>
      </div>
    </div>
  )
}
